import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function ProjectsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.projects.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
